import Vue from 'vue'
import Vuex from 'vuex'
import { IAppState } from './modules/app'
import { IUserState } from './modules/user'

Vue.use(Vuex)

export interface IRootState {
    peListQuery: any
  app: IAppState
  user: IUserState
}

export default new Vuex.Store<IRootState>({
  state: {
    peListQuery: {
      orderStatus: 0,
      page: 1,
      pageSize: 10,
      input: '',
      phone: '',
      zjh: '',
      tjbh:'',
      valueTime: []
    }
  },
  mutations: {
    UPDATE_PE_LIST_QUERY(state, query) {
      state.peListQuery = query;
      // 将状态保存到 localStorage
      localStorage.setItem('peListQuery', JSON.stringify(query));
    }
  },
  actions: {
    savePeListQuery({ commit }, query) {
      commit('UPDATE_PE_LIST_QUERY', query);
    },
    getPeListQuery({ state }) {
      // 尝试从 localStorage 中恢复状态
      const savedQuery = localStorage.getItem('peListQuery');
      if (savedQuery) {
        state.peListQuery = JSON.parse(savedQuery);
      }
      return state.peListQuery;
    }
  },
  getters: {
    getPeListQuery: state => state.peListQuery
  }
});
